/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Review/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Answer from './Answer/index'
import Progress from './Progress/index'
import React from 'react'
import SubmittingInfo from './SubmittingInfo/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Review({
  children,
  viewPath = "/App/Widget/Content/Questions/Review"
  
}) {
let selectedFlowQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'flowQuestions',
})
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let selectedCurrentQuestionIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'current_question_id',
})
let aggregateData = fromHelpers.questionsAndAnswers(selectedFlowQuestionsValueData, widgetQuestionsValueData, selectedAnswersValueData, selectedCurrentQuestionIdValueData)
  return (<React.Fragment
>
<div
  data-testid="Review.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Progress
  viewPath={`${viewPath}/Progress`}
/>
<SubmittingInfo
  viewPath={`${viewPath}/SubmittingInfo`}
/>
<div
  data-testid="Review.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Review.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(aggregateData) && aggregateData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="answer"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Answer(${item?.id ?? item?._id ?? index})`}
      >
<Answer
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Answer(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }